module.exports = __webpack_public_path__ + "media/application/images/icons/book_white-900e026a57852622b6bd464f223d89ec.svg";